import { createModule } from "../../utils";

export const helloWorld = createModule("test", {
  theSecret: "the-secret-of-getting-ahead-is-getting-started",
  helloWorld: "hello-world"
});
